import { Subject } from "rxjs";

export const organizationEvent$ = new Subject();

export const searchChatEvent$ = new Subject();

export const sideBarFeatureEvent$ = new Subject();

export const downloadEvent$ = new Subject();

export const uploadEvent$ = new Subject();
